import $api from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";
import { AxiosResponse } from "axios";

class KycFileArchiveEndpoint {
  public kyc_list(params: AxiosRequestConfig = {}) {
    return $api.get("a/kyc-file-archives", params);
  }

  public download(
    id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    params.responseType = "blob";

    return $api.get(`a/kyc-file-archives/${id}/download`, params);
  }
}

export default KycFileArchiveEndpoint;
